import React, { useEffect, useState } from "react";

import { fundsApi } from "../../../../../../services/fundServices";
import {
  useFundTransactionModal,
  initialState,
} from "../../../../../../providers/fundTransactionModalProvider";
import ConfirmationModal from "../../../../../ConfirmationModal";
import { useFundContext } from "../../../../../../providers/fundsProvider";
import Loader from "../../../../../Loader";
import CategoryCreationModal from "../../../../CategoryCreationModal";
import FundMonthTransactionDetailModal from "./FundMonthTransactionDetailModal";
import FundMonthTransactionCreationModal from "./FundMonthTransactionCreationModal";

const CREATION_MODE = 1;
const DETAIL_MODE = 4;
const DELETE_CONFIRMATION_MODE = 5;
const CATEGORY_CREATION_MODE = 2;

const FundMonthTransactionModal = () => {
  const [loading, setLoading] = useState(false);
  const [fundTransactionModal, setFundTransactionModal] =
    useFundTransactionModal();

  const [fundContext, setFundContext] = useFundContext();
  const fund = fundContext.fund;

  useEffect(() => {
    fundsApi.getFundTransactionCategories({}).then((result) => {
      setFundTransactionModal({ categories: result.data });
      setLoading(false);
    });
  }, [setFundTransactionModal]);

  const onCategorySubmit = (data) => {
    setLoading(true);
    fundsApi.createFundTransactionCategory(data).then((result) => {
      setLoading(false);
      setFundTransactionModal({
        categories: [...fundTransactionModal.categories, result],
        fundTransactionCategoryId: result.id,
        mode: CREATION_MODE,
      });
    });
  };

  const onDeleteFundTransaction = () => {
    setLoading(true);
    fundsApi
      .deleteFundTransaction({ id: fundTransactionModal.id, fundId: fund?.id })
      .then(() =>
        fundsApi
          .getFundMonths({
            fundId: fund.id,
            id: fundTransactionModal.fundMonthId,
          })
          .then((selectedFundMonth) => {
            setLoading(false);
            setFundTransactionModal({ ...initialState });
            let fundMonths = fundContext.fundMonths;
            fundMonths.splice(
              fundMonths.findIndex(
                (fq) => fq.id === fundTransactionModal.fundMonthId
              ),
              1,
              selectedFundMonth
            );
            setFundContext({ selectedFundMonth, fundMonths });
          })
      );
  };

  switch (fundTransactionModal.mode) {
    case CREATION_MODE:
      return <FundMonthTransactionCreationModal />;
    case CATEGORY_CREATION_MODE:
      return (
        <CategoryCreationModal
          loading={loading}
          onSubmit={onCategorySubmit}
          categories={fundTransactionModal.categories}
          onClose={() => setFundTransactionModal({ mode: CREATION_MODE })}
        />
      );
    case DETAIL_MODE:
      return <FundMonthTransactionDetailModal />;
    case DELETE_CONFIRMATION_MODE:
      const data = {
        onSubmit: onDeleteFundTransaction,
        onClose: () => setFundTransactionModal({ mode: DETAIL_MODE }),
        title: "Remove Transaction",
        body: "Do you confirm you want to remove the transaction?",
      };
      return loading ? <Loader size="sm" /> : <ConfirmationModal {...data} />;
    default:
      return null;
  }
};

export default FundMonthTransactionModal;
